import { Link, useNavigate } from "react-router-dom";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/cn";
import { useAuthStore } from "@/stores/auth-store";
import { useThemeStore } from "@/stores/theme-store";

const linkButtonClass = cn(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors h-9 px-3",
);

export function SiteHeader(): JSX.Element {
  const navigate = useNavigate();
  const status = useAuthStore((s) => s.status);
  const signout = useAuthStore((s) => s.signout);
  const theme = useThemeStore((s) => s.theme);
  const toggleTheme = useThemeStore((s) => s.toggle);

  const handleSignout = (): void => {
    signout();
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-30 w-full border-b border-border bg-background/80 backdrop-blur">
      <div className="container flex h-14 items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 text-base font-semibold tracking-tight"
          aria-label="Devit 홈"
        >
          <img
            src="/devit-logo-112.png"
            alt=""
            className="h-7 w-7 rounded"
            width={28}
            height={28}
          />
          <span className="sr-only">devit</span>
        </Link>
        <nav className="flex items-center gap-2 text-sm">
          <button
            type="button"
            onClick={toggleTheme}
            aria-label={theme === "dark" ? "라이트 모드로" : "다크 모드로"}
            title={theme === "dark" ? "라이트 모드로" : "다크 모드로"}
            className="inline-flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
          >
            {theme === "dark" ? (
              <Sun className="h-4 w-4" />
            ) : (
              <Moon className="h-4 w-4" />
            )}
          </button>
          {status === "authenticated" ? (
            <>
              <Link
                to="/app"
                className={cn(linkButtonClass, "hover:bg-accent hover:text-accent-foreground")}
              >
                대시보드
              </Link>
              <Button variant="outline" size="sm" onClick={handleSignout}>
                로그아웃
              </Button>
            </>
          ) : (
            <>
              <Link
                to="/pricing"
                className={cn(linkButtonClass, "hover:bg-accent hover:text-accent-foreground")}
              >
                가격
              </Link>
              <Link
                to="/login"
                className={cn(linkButtonClass, "hover:bg-accent hover:text-accent-foreground")}
              >
                로그인
              </Link>
              <Link
                to="/signup"
                className={cn(
                  linkButtonClass,
                  "bg-primary text-primary-foreground hover:bg-primary/90",
                )}
              >
                시작하기
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
